/**
 * borra-me.com brand mark.
 * Minimal monochrome icon: black rounded square + white "delete" strikethrough
 * + red status dot. Designed to read clearly at 16px (favicon) and at 128px+.
 */
export default function Logo({ size = 28, withAccent = true, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-label="borra-me.com"
      role="img"
    >
      <rect width="64" height="64" rx="14" fill="#0F172A" />
      <rect x="14" y="29" width="36" height="6" rx="1" fill="#FFFFFF" />
      {withAccent && <circle cx="49" cy="15" r="4" fill="#DC2626" />}
    </svg>
  );
}
